import React, { useContext, useMemo } from "react";
import { Autocomplete, FilterBar, SearchBar, Switch } from "@sscs/ui";
import { produce } from "immer";
import { initFilter } from "../../../store/signaturesSlice";
import { ReportContext } from "../../context";
import { useLazyGetSignaturePoliciesQuery } from "../../services/signatures.api";
const Filter = ({ filter, onFilterChange }) => {
    const { reportId } = useContext(ReportContext);
    const [getPolicies, { data: policiesData, isFetching: isPoliciesFetching }] = useLazyGetSignaturePoliciesQuery();
    if (!policiesData &&
        !isPoliciesFetching &&
        filter.policy_id !== initFilter.policy_id) {
        // When returning to the page after navigating away and there is a policy filter applied
        // the getPolicy query will not have been run due to be lazy loaded onOpen of the autocomplete,
        // resulting in incomplete option label display. [SWAP-1809]
        getPolicies({ ui_id: reportId }, true);
    }
    const policies = useMemo(() => {
        if (!policiesData)
            return {};
        return policiesData.reduce((policiesObj, policy) => {
            policiesObj[policy.id] = policy.value;
            return policiesObj;
        }, {});
    }, [policiesData]);
    const policyIds = Object.keys(policies);
    return (React.createElement(FilterBar, { filters: [
            {
                id: "policy",
                minWidth: "300px",
                control: (React.createElement(Autocomplete, { id: "signatures-policy-filter", label: "Filter by policy ID - description", isClearAlwaysVisible: filter.policy_id !== initFilter.policy_id, value: filter.policy_id, options: policyIds, loading: isPoliciesFetching, onOpen: () => getPolicies({ ui_id: reportId }, true), getOptionLabel: (policyId) => { var _a; return `${policyId} - ${(_a = policies[policyId]) !== null && _a !== void 0 ? _a : ""}`; }, onChange: (_, value) => {
                        onFilterChange(produce(filter, (draftState) => {
                            draftState.policy_id = value;
                        }));
                    }, fullWidth: true })),
            },
            {
                id: "identity",
                minWidth: "300px",
                control: (React.createElement(SearchBar, { id: "signature-identity-search", value: filter.identity, onChange: (value) => onFilterChange(produce(filter, (draftState) => {
                        draftState.identity = value;
                    })), label: "Regex search for signature identity", slotProps: { htmlInput: { maxLength: 256 } } })),
            },
            {
                id: "only-violations",
                fit: true,
                control: (React.createElement(Switch, { title: "Filter signatures", label: "With issues", id: "signatures-issues-filter", checked: filter.only_violations, onChange: (event) => onFilterChange(produce(filter, (draftState) => {
                        draftState.only_violations = event.target.checked;
                    })) })),
            },
        ] }));
};
export default Filter;
//# sourceMappingURL=Filter.js.map